import gestionDateBase from '@/services/general/gestionDateBase';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import trierIntervenants from '@/services/devisCommandes/trierIntervenants';
import * as devisConf from '@/configuration/devisConf';

export default function postGetCommandesList(commande) {
  commande.selected = false;
  commande.dateDevisCommande = gestionDateBase(commande.dateDevisCommande);
  const etat = devisConf.DEVIS_COMMANDE_ETAT.find((el) => {
    return el.code === commande.etat;
  });
  if (etat) {
    commande.etatLibelle = etat.libelle;
  }
  if (commande.commercial) {
    commande.nomCommercial = nomPrenomGetter(commande.commercial);
  }
  let listeIntervenants = '';
  trierIntervenants(commande);
  listeIntervenants = commande.intervenants.map((el) => el.nomCommercial).join(', ');
  commande.listeIntervenants = listeIntervenants;
}
